import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Icon } from 'semantic-ui-react'

import { getImageURL, IMAGE_SIZES } from '../../constants'
import ImageSchema from '../../schemas/ImageSchema'

import styles from './index.css'

export const ImagePropTypes = {
  className: PropTypes.string,
  fallback: PropTypes.element,
  fallbackIconName: PropTypes.string,
  fallbackText: PropTypes.string,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  src: ImageSchema,
  srcImageSize: PropTypes.oneOf(Object.values(IMAGE_SIZES)),
  style: PropTypes.object,
  wrapperStyle: PropTypes.object,
}

export const ImageDefaultProps = {
  className: null,
  fallback: null,
  fallbackIconName: 'image outline',
  fallbackText: '',
  onError: Function.prototype,
  onLoad: Function.prototype,
  src: null,
  srcImageSize: null,
  style: null,
  wrapperStyle: null,
}

class Image extends PureComponent {
  state = {
    error: false,
    loaded: false,
  }

  getFallbackTextInitials = () =>
    this.props.fallbackText
      .split(' ', 2)
      .map((word) => word[0])
      .join('')
      .toLocaleUpperCase()

  onError = () => {
    this.setState({ error: true })
    this.props.onError(this.props)
  }

  onLoad = () => {
    this.setState({ loaded: true })
    this.props.onLoad(this.props)
  }

  renderFallback = () =>
    this.props.fallback ||
    (!!this.props.fallbackText && this.renderFallbackText()) || (
      <Icon className="scale-75" color="grey" fitted name={this.props.fallbackIconName} />
    )

  renderFallbackText = () => <span className={styles.fallbackText}>{this.getFallbackTextInitials()}</span>

  renderImage = () => {
    const { src, srcImageSize, style } = this.props
    const imageURL = src.filename ? getImageURL(src.filename, srcImageSize) : src

    return (
      <img alt="shield" aria-label="shield" onError={this.onError} onLoad={this.onLoad} src={imageURL} style={style} />
    )
  }

  render() {
    const { className, fallbackIconName, fallbackText, src, srcImageSize, wrapperStyle, ...props } = this.props
    const { error, loaded } = this.state

    return (
      <span
        {...props}
        className={classnames(className, styles.wrapper, error && styles.error, loaded && styles.loaded)}
        style={wrapperStyle}
      >
        {!error && src ? this.renderImage() : this.renderFallback()}
      </span>
    )
  }
}

Image.propTypes = ImagePropTypes

Image.defaultProps = ImageDefaultProps

export default Image
